export default "__VITE_ASSET__D54ScTL7__"